import { useCallback, useState } from 'react';

import { ILocalization, ILocalizationToken } from '../../../../../../application/language/ILocalization';
import { inject } from '../../../../../../common/container/inject';
import { LayoutNotificationType } from '../../../../common/notification/store/ILayoutNotification';
import { IMainLayoutDomainStore } from '../../../store/domain/IMainLayoutDomainStore';

type Args = {
  layoutDomain: IMainLayoutDomainStore;
  handleClose: () => void;
  showOldPassword?: boolean;
};

export const usePasswordForm = ({ layoutDomain, handleClose, showOldPassword = false }: Args) => {
  const [i18n] = useState(inject<ILocalization>(ILocalizationToken));
  const [formErrors, setFormErrors] = useState<Record<string, string>>({
    oldPassword: ' ',
    password: ' ',
  });

  const sendNotification = useCallback((type: LayoutNotificationType, text: string) => {
    setTimeout(() => {
      layoutDomain.notifications.showNotification({
        type,
        text,
      });
      // Добавлена задержка 1000 для предотвращения race condition при перезагрузке страницы.
      // Без неё уведомление может исчезнуть до отображения.
    }, 1000);
  }, [layoutDomain.notifications])


  const handleSubmit = async ({
    oldPassword,
    newPassword,
    confirmPassword,
  }: {
    oldPassword?: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    if (showOldPassword && newPassword === oldPassword) {
      return setFormErrors({ oldPassword: i18n.translate('updatePassword.newAndOldPasswordSame') });
    }

    let errMsg: string | void = '';

    if (showOldPassword) {
      errMsg = await layoutDomain.updatePassword({
        newPassword,
        confirmPassword,
        oldPassword,
      });
    } else {
      errMsg = await layoutDomain.forceChangePassword({
        newPassword,
        confirmPassword,
      });
    }

    if (errMsg === 'Old password is incorrect') {
      return setFormErrors({
        oldPassword: i18n.translate('updatePassword.oldPasswordIncorrect') || 'Password change error',
      });
    } else if (errMsg === 'The new password must not be the same as the old one') {
      setFormErrors({
        password: i18n.translate('updatePassword.newAndOldPasswordSame') || errMsg
      })
      return;
    } else if (errMsg === 'User does not have the required directive to change password') {
      sendNotification(LayoutNotificationType.info, i18n.translate('updatePassword.directiveMissing'));
      layoutDomain.loadLayoutData();
      return;
    }
    handleClose()
  };



  return { handleSubmit, formErrors, setFormErrors };
};
